import React from 'react';
import clsx from 'clsx';
import makeStyles from '@mui/styles/makeStyles';
import Legend from './legend';
import TabbedLegend from './tabbedLegend';

const useStyles = makeStyles((theme) => ({
  hiddenContainer: { ...theme.palette.hiddenContainer },
  legendContainer: {
    position: 'absolute',
    right: '160px',
    bottom: '10px',
    maxWidth: 'calc(100% - 258px)',
  },
  legendContainerTabbed: {
    right: '186px',
  },
}));

export default (props) => {
  const classes = useStyles();
  return (
    <div
      id="legend-container"
      ref={props.containerRef}
      className={clsx(classes.legendContainer, {
        [classes.hiddenContainer]: !props.enabled,
        [classes.legendContainerTabbed]: !!props.tabbed,
        [props.styles?.legendContainer]: !!props.styles?.legendContainer,
      })}
    >
      {props.tabbed ? <TabbedLegend {...props} /> : <Legend {...props} />}
    </div>
  );
};
